import { render, staticRenderFns } from "./KnExpenseCategories.vue?vue&type=template&id=71c737a0&"
import script from "./KnExpenseCategories.vue?vue&type=script&lang=js&"
export * from "./KnExpenseCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports